module.exports = __webpack_public_path__ + "img/LEXE-MIN.e5a540ef.png";